export default __webpack_public_path__ + "ba412203b0216a92f41b2e33f4633762.png";